var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unidata-editor",staticStyle:{"padding":"3px"}},[_c('div',{staticClass:"row mr-0"},[(_vm.title != '')?_c('div',{staticClass:"col-8"},[_c('label',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.uniToolTipTranslation(_vm.title, 'en-US')),expression:"uniToolTipTranslation(title, 'en-US')"}],staticClass:"label-picker"},[_vm._v("\n        "+_vm._s(_vm.uniTranslation(_vm.title)))])]):_vm._e(),_vm._l((_vm.values),function(val,index){return _c('div',{key:index,class:'col-2 unidata-item-container'},[_c('VueAutonumeric',{staticClass:"form-control auto-numeric",attrs:{"options":{
          allowDecimalPadding: false,
          digitGroupSeparator: '',
          decimalCharacter: ',',
          decimalCharacterAlternative: '.',
          decimalPlaces: _vm.decimals,
          currencySymbol: '\u00a0€',
          currencySymbolPlacement: 's',
          roundingMethod: 'D' /* 'U' */,
          symbolWhenUnfocused: '',
          selectOnFocus: 'false',
          currencySymbol: '',
          negativePositiveSignPlacement: 'p',
          minimumValue: _vm.min
        }},on:{"blur":function($event){return _vm.change(index)}},model:{value:(_vm.values[index]),callback:function ($$v) {_vm.$set(_vm.values, index, $$v)},expression:"values[index]"}})],1)})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }